import styled from "@emotion/styled";
import { FormControl } from "@mui/material";

export const FormControlWrapper = styled(FormControl)({
  marginTop: "16px",
  marginBottom: "16px",
});
